import { render, staticRenderFns } from "./KYCRequestCreateModal.vue?vue&type=template&id=60ef44d6&scoped=true"
import script from "./KYCRequestCreateModal.vue?vue&type=script&lang=js"
export * from "./KYCRequestCreateModal.vue?vue&type=script&lang=js"
import style0 from "./KYCRequestCreateModal.vue?vue&type=style&index=0&id=60ef44d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ef44d6",
  null
  
)

export default component.exports